import type { SupplyingData } from "@/features/product-stocks/types";
import { apiClient } from "@/lib/apiClient";

export interface Supplying extends SupplyingData {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export const SUPPLYINGS_KEY = "supplying";

export const listSupplyings = async (): Promise<Supplying[]> => {
  const result = await apiClient.get<Supplying[]>(SUPPLYINGS_KEY);
  return Array.isArray(result) ? result : [];
};

export const getSupplying = (id: string): Promise<Supplying> => apiClient.get<Supplying>(`supplying/${id}`);

export const createSupplying = (data: SupplyingData): Promise<Supplying> =>
  apiClient.post<Supplying>(SUPPLYINGS_KEY, data);

export const updateSupplying = (id: string, data: Partial<SupplyingData>): Promise<Supplying> =>
  apiClient.put<Supplying>(`supplying/${id}`, data);

export const deleteSupplying = (id: string): Promise<unknown> => apiClient.delete(`supplying/${id}`);
